export default __webpack_public_path__ + "static/media/avatar_nv_3.ea210198.jpg";